<div class="copy_link_container" [@copyLinkState]="state" (@copyLinkState.done)="onCompleteAnimation()">
  <div class="title">Link Copied</div>
  <div class="copy_block">
    <p class="link_to_copy">{{copyUrl}}</p>
  </div>
  <close-button (close)="onCloseCopyLink()" class="close_icon"></close-button>
</div>
<div class="overlay" (click)="onCloseCopyLink()"></div>
